export default __webpack_public_path__ + "static/media/04.efe52813.jpg";